import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './component/home/home'
import Footer from './component/Footer/footer'
import About from './component/about/about'
import Gallery from './component/gallery/gallery'
import Contact from './component/contact/Contact'
import Doctor from './component/Doctor/Doctor'
import Gservices from './component/Services/Gsrvices'
import Privacy from './component/privacy_policy/Privacy'
import Sitemap from './component/sitemap/Sitemap'
import Award from './component/award/Award'
import Services from './component/Services/Services'
import { HelmetProvider } from 'react-helmet-async'
import Makeappointment from './component/home/make_appointment/makeappointment'
import { MedicalTourism } from './component/Services/MedicalTourism'
import Asthma from './component/Services/asthma/Asthma'
import Weightloss from './component/Services/Weight loss/Weightloss'
import Allergy from './component/Services/Allergy/Allergy'
import Glutathione from './component/Services/glutathione/Glutathione'
import Laserhair from './component/Services/Laserhair/Laserhair'
import Acne from './component/Services/Acne/Acne'
import Hairtransplant from './component/Services/Hair Transplant/Hairtransplant'
import Fillers from './component/Services/Fillers/Fillers'
import Threads from './component/Services/Threads/Threads'
import Antiaging from './component/Services/Anti-aging treatment/Antiaging'
import Microneedling from './component/Services/Microneedling/Microneedling'
import ChemicalPeel from './component/Services/Chemical Peel/ChemicalPeel'
import Blogall from './component/blog/Blogall'
import BlogPost from './component/blog/BlogPost'
import BlogList from './component/blog/BlogList'
import CreatePost from './component/blog/CreatePost'
import BlogDetails from './component/blog/BlogDetails'
import LocationTreatmentPage from './component/Services/LocationPages/LocationTreatmentPage'

function App() {
  useEffect(() => {
    const handleOutboundClick = (event) => {
      const link = event.target.closest('a[href]')
      if (!link) return

      let url
      try {
        url = new URL(link.href, window.location.href)
      } catch (e) {
        return
      }

      const isExternal = url.hostname && url.hostname !== window.location.hostname

      if (isExternal && window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-11422192869/nBSqCMOzx-UcEOWpw8Yq',
          value: 1.0,
          currency: 'INR',
        })
      }
    }

    document.addEventListener('click', handleOutboundClick)
    return () => document.removeEventListener('click', handleOutboundClick)
  }, [])

  return (
    <HelmetProvider>
      <div className='App'>
        {/* <Popup /> */}
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/bloglist' element={<BlogList />} />
            <Route path='/blogeditor' element={<CreatePost />} />
            <Route path='/blogdetails' element={<BlogDetails />} />
            <Route path='/about' element={<About />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/award' element={<Award />} />
            <Route path='/doctor' element={<Doctor />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='/sitemap' element={<Sitemap />} />
            <Route path='/drSweta/:section' element={<Services />} />
            <Route path='/drgaurav/:section' element={<Gservices />} />
            <Route path='/asthma' element={<Asthma />} />
            <Route path='/weight-loss' element={<Weightloss />} />
            <Route path='/allergy' element={<Allergy />} />
            <Route path='/glutathione' element={<Glutathione />} />
            <Route path='/laser-hair-reduction' element={<Laserhair />} />
            <Route path='/acne' element={<Acne />} />
            <Route path='/hair-transplant' element={<Hairtransplant />} />
            <Route path='/filler' element={<Fillers />} />
            <Route path='/thread' element={<Threads />} />
            <Route path='/anti-aging-treatment' element={<Antiaging />} />
            <Route path='/microneedling' element={<Microneedling />} />
            <Route path='/chemical-peel' element={<ChemicalPeel />} />
            <Route path='/blog' element={<Blogall />} />
            <Route path='/blog/:slug' element={<BlogPost />} />
            <Route path='/medical-tourism' element={<MedicalTourism />} />
            <Route path='/appoint' element={<Makeappointment />} />
            {/* Location-specific treatment pages */}
            <Route path='/treatment/:slug' element={<LocationTreatmentPage />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </div>
    </HelmetProvider>
  )
}
export default App
